import baseApi from ".";
import createQueryFn from "../createQueryFn";
import api from "api";
import { CreateReasonRequest, CreateReasonResponse } from "api/order-incomplete-reasons/createReason";
import { GetAllReasonsRequest, GetAllReasonsResponse } from "api/order-incomplete-reasons/getAllReasons";
import { UpdateReasonRequest, UpdateReasonResponse } from "api/order-incomplete-reasons/updateReason";

const reasonsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    createReason: builder.mutation<CreateReasonResponse, CreateReasonRequest>({
      queryFn: createQueryFn(api.orderIncompleteReasons.createReason),
      invalidatesTags: [{ type: "OrderIncompleteReason", id: "LIST" }],
    }),
    getAllReasons: builder.query<GetAllReasonsResponse, GetAllReasonsRequest | void>({
      queryFn: createQueryFn(api.orderIncompleteReasons.getAllReasons),
      providesTags: [{ type: "OrderIncompleteReason", id: "LIST" }],
    }),
    updateReason: builder.mutation<UpdateReasonResponse, UpdateReasonRequest>({
      queryFn: createQueryFn(api.orderIncompleteReasons.updateReason),
      invalidatesTags: [{ type: "OrderIncompleteReason", id: "LIST" }],
    }),
  }),
});

export const {
  useCreateReasonMutation,
  useGetAllReasonsQuery,
  useUpdateReasonMutation,
} = reasonsApi;

export default reasonsApi;
